<div
  class="resume-compact"
  [style.font-family]="font"
  [style.--themeColor]="color"
>
  <div class="container">
    <div class="col-left">
      <div class="profile-img" *ngIf="data?.config?.photoUrl">
        <img [src]="data.config.photoUrl" crossorigin="anonymous" />
      </div>

      <h2 *ngIf="data?.personal_info?.fullName">
        {{ data.personal_info.fullName }}
      </h2>

      <p class="role" *ngIf="data?.targetRole">
        {{ data.targetRole }}
      </p>

      <div
        class="block"
        *ngIf="
          data?.personal_info?.email ||
          data?.personal_info?.phone ||
          data?.personal_info?.location ||
          data?.personal_info?.linkedinUrl ||
          data?.personal_info?.githubUrl
        "
      >
        <p *ngIf="data?.personal_info?.email">
          <i class="bi bi-envelope"></i> {{ data.personal_info.email }}
        </p>

        <p *ngIf="data?.personal_info?.phone">
          <i class="bi bi-telephone"></i> {{ data.personal_info.phone }}
        </p>

        <p *ngIf="data?.personal_info?.location">
          <i class="bi bi-geo-alt"></i> {{ data.personal_info.location }}
        </p>

        <p *ngIf="data?.personal_info?.linkedinUrl">
          <i class="bi bi-linkedin"></i> {{ data.personal_info.linkedinUrl }}
        </p>

        <p *ngIf="data?.personal_info?.githubUrl">
          <i class="bi bi-github"></i> {{ data.personal_info.githubUrl }}
        </p>
      </div>

      <div class="block mt-4" *ngIf="data?.skills?.technicalSkills?.length">
        <h4>Skills</h4>
        <p>{{ data.skills.technicalSkills.join(", ") }}</p>
      </div>

      <div class="block" *ngIf="data?.skills?.tools?.length">
        <h4>Tools</h4>
        <p>{{ data.skills.tools.join(", ") }}</p>
      </div>

      <div class="block" *ngIf="data?.skills?.softSkills?.length">
        <h4>Soft Skills</h4>
        <p>{{ data.skills.softSkills.join(", ") }}</p>
      </div>

      <div class="block" *ngIf="data?.extras?.languages?.length">
        <h4>Languages</h4>

        <ng-container *ngFor="let l of data.extras.languages">
          <p *ngIf="l?.name">
            {{ l.name }}
            <span *ngIf="l?.proficiency">({{ l.proficiency }})</span>
          </p>
        </ng-container>
      </div>
    </div>

    <div class="col-right">
      <div class="block" *ngIf="data?.summary">
        <h4>Summary</h4>
        <p>{{ data.summary }}</p>
      </div>

      <div class="block" *ngIf="data?.education?.length">
        <h4>Education</h4>

        <ng-container *ngFor="let e of data.education">
          <div
            class="item"
            *ngIf="e?.collegeName || e?.degree || e?.startYear || e?.endYear"
          >
            <div
              class="row"
              *ngIf="e?.collegeName || e?.startYear || e?.endYear"
            >
              <strong *ngIf="e?.collegeName">{{ e.collegeName }}</strong>

              <span class="date" *ngIf="e?.startYear || e?.endYear">
                <ng-container *ngIf="e?.startMonth || e?.startYear">
                  {{ e?.startMonth }} {{ e?.startYear }}
                </ng-container>

                <span *ngIf="(e?.startYear || e?.startMonth) && e?.endYear">
                  -
                </span>

                <ng-container *ngIf="e?.endMonth || e?.endYear">
                  {{ e?.endMonth }} {{ e?.endYear }}
                </ng-container>
              </span>
            </div>

            <p *ngIf="e?.degree || e?.location">
              {{ e?.degree }}
              <span *ngIf="e?.degree && e?.location">, </span>
              {{ e?.location }}
            </p>

            <p *ngIf="e?.cgpa_or_percentage">
              CGPA: {{ e.cgpa_or_percentage }}
            </p>
          </div>
        </ng-container>
      </div>

      <div class="block" *ngIf="data?.projects?.length">
        <h4>Projects</h4>

        <ng-container *ngFor="let p of data.projects">
          <div class="item" *ngIf="p?.title || p?.description">
            <strong *ngIf="p?.title">{{ p.title }}</strong>

            <p class="tech" *ngIf="p?.technologies?.length">
              {{ p.technologies.join(", ") }}
            </p>

            <p *ngIf="p?.description">{{ p.description }}</p>

            <p *ngIf="p?.outcome" class="link">↗ {{ p.outcome }}</p>
          </div>
        </ng-container>
      </div>

      <div class="block" *ngIf="data?.experience?.length">
        <h4>Experience</h4>

        <ng-container *ngFor="let e of data.experience">
          <div class="item" *ngIf="e?.role || e?.company">
            <div class="row" *ngIf="e?.role || e?.startYear">
              <strong>
                <span *ngIf="e?.role">{{ e.role }}</span>
                <span *ngIf="e?.role && e?.company"> - </span>
                <span *ngIf="e?.company">{{ e.company }}</span>
              </strong>

              <span
                class="date"
                *ngIf="e?.startYear || e?.endYear || e?.currently_working"
              >
                <ng-container *ngIf="e?.startMonth || e?.startYear">
                  {{ e?.startMonth }} {{ e?.startYear }}
                </ng-container>

                <span
                  *ngIf="e?.startYear && (e?.endYear || e?.currently_working)"
                >
                  -
                </span>

                <ng-container *ngIf="e?.currently_working"
                  >Present</ng-container
                >

                <ng-container *ngIf="!e?.currently_working">
                  {{ e?.endMonth }} {{ e?.endYear }}
                </ng-container>
              </span>
            </div>

            <p class="location" *ngIf="e?.location">
              {{ e.location }}
            </p>

            <p *ngIf="e?.description">{{ e.description }}</p>
          </div>
        </ng-container>
      </div>

      <div class="block" *ngIf="data?.extras?.certifications?.length">
        <h4>Certifications</h4>

        <ng-container *ngFor="let c of data.extras.certifications">
          <p *ngIf="c?.name || c?.platform || c?.year">
            <span *ngIf="c?.name">• {{ c.name }}</span>

            <span *ngIf="c?.platform || c?.year">
              ({{ c?.platform }}
              <span *ngIf="c?.platform && c?.year"> - </span>
              {{ c?.year }})
            </span>
          </p>
        </ng-container>
      </div>

      <div class="block" *ngIf="data?.extras?.awards?.length">
        <h4>Awards</h4>

        <ng-container *ngFor="let a of data.extras.awards">
          <p *ngIf="a?.name || a?.organization">
            • {{ a?.name }}
            <span *ngIf="a?.organization">({{ a.organization }})</span>
          </p>
        </ng-container>
      </div>

      <div class="block" *ngIf="data?.extras?.hackathons?.length">
        <h4>Hackathons</h4>

        <ng-container *ngFor="let h of data.extras.hackathons">
          <p *ngIf="h?.name || h?.rank">
            • {{ h?.name }}
            <span *ngIf="h?.rank">({{ h.rank }})</span>
          </p>
        </ng-container>
      </div>

      <div class="block" *ngIf="data?.extras?.languages?.length">
        <h4>Languages</h4>

        <ng-container *ngFor="let language of data.extras.languages">
          <p *ngIf="language?.name">
            • {{ language.name }}
            <span *ngIf="language?.proficiency"
              >({{ language.proficiency }})</span
            >
          </p>
        </ng-container>
      </div>
    </div>
  </div>
</div>
